import { Observable, ReplaySubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./helpers";
export class CacheService {
    constructor(http, helper) {
        this.http = http;
        this.helper = helper;
        this.contractors = [];
        this.contractors$ = new ReplaySubject(1);
        this.contractor$ = {};
    }
    getContractors(force = false) {
        this.loadContractors(force);
        if (force) {
            this.contractors$ = new ReplaySubject(1);
        }
        return this.contractors$;
    }
    getContractor(id) {
        if (!this.contractor$[id]) {
            this.contractor$[id] = new ReplaySubject(1);
        }
        this.loadContractor(id);
        return this.contractor$[id];
    }
    reloadContractor(id) {
        this.loadContractor(id, true);
        //this.loadContractors(true);
    }
    loadContractors(force = false) {
        if (this.contractors.length === 0 || force) {
            this.http.get(this.helper.getApiUrl('/zdravstvene-ustanove')).subscribe((contractors) => {
                this.contractors$.next(contractors);
                this.contractors = contractors;
            });
        }
    }
    loadContractor(id, force = false) {
        let contractor = null;
        if (this.contractors.length > 0) {
            contractor = this.contractors.findIndex((con) => {
                return con.id === id;
            });
        }
        if (contractor === null || contractor === -1 || force) {
            this.http.get(this.helper.getApiUrl('/zdravstvene-ustanove/' + id)).subscribe((newContractor) => {
                if (contractor === null || contractor === -1) {
                    this.contractors.push(newContractor);
                }
                else {
                    this.contractors[contractor] = newContractor;
                }
                this.contractor$[id].next(newContractor);
                this.contractors$.next(this.contractors);
            });
        }
    }
}
CacheService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CacheService_Factory() { return new CacheService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.HelperService)); }, token: CacheService, providedIn: "root" });
